import { useMemo } from 'react'
import { Props } from '../PaymentRequirements'
import { permissionDenied } from '@user/store/authorization/permissions'
import { LEAD_STATUSES } from '@user/components/Leads/LeadCard/typings'
import { OPPORTUNITY_STATUSES } from '@user/components/Opportunities/OpportunityCard/typings'

export function useData(props: Props) {
  const { canUpdate, entityType, leadStatus, locationId, oppStatus } = props

  const isDisqualifiedLead =
    !!leadStatus && leadStatus == LEAD_STATUSES.Disqualified

  const isLostOpportunity =
    !!oppStatus && oppStatus == OPPORTUNITY_STATUSES.Lost

  const isDisabled =
    !canUpdate || isDisqualifiedLead || isLostOpportunity || !locationId

  const disabledText = useMemo(() => {
    if (!canUpdate) return permissionDenied

    if (isLostOpportunity) {
      return `You cannot capture payment information for a closed lost Opportunity.`
    }

    if (isDisqualifiedLead) {
      return `You cannot capture payment information for a disqualified Lead.`
    }

    if (!locationId) {
      return `Link this ${entityType.toLowerCase()} to a location to view/capture payment information.`
    }
  }, [canUpdate, entityType, isDisqualifiedLead, isLostOpportunity, locationId])

  return { isDisqualifiedLead, isLostOpportunity, isDisabled, disabledText }
}
